import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";
import {
  OnboardingTarget,
  onboardingTarget,
} from "../onboarding/onboardingTargets";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentLanguage,
  selectLocalizedLanguages,
  setCurrentLanguage,
} from "../../app/slices/TrainingLocalizationSlice";
import PiDropdown from "../../components/PiDropdown";
import TrainingLocalizationDialog from "../trainingLocalization/TrainingLocalizationDialog";

export default function LocalizationGroup() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const localizedLanguages = useSelector(selectLocalizedLanguages);
  const selectedLanguage = useSelector(selectCurrentLanguage);

  const onChangeLanguageDropdown = (newLang: string) => {
    dispatch(
      setCurrentLanguage(
        localizedLanguages.find((lang) => lang.full === newLang)!
      )
    );
  };

  return (
    <>
      <div className="trainingactionbar-localization">
        <div className="trainingactionbar-localization-zone">
          <div className="trainingactionbar-localization-dropdown">
            <PiDropdown
              options={localizedLanguages.map((option) => ({
                text: option.full,
                onClick: () => onChangeLanguageDropdown(option.full),
              }))}
              selectedText={selectedLanguage.full}
            />
          </div>
          <div className="trainingactionbar-localization-button">
            {/* Had no accessible name at all — it announced as "button". */}
            <IconButton
              color="inherit"
              onClick={() => setIsOpen(true)}
              aria-label={String(t("localizations"))}
              {...onboardingTarget(OnboardingTarget.ActionbarTranslate)}
            >
              <TranslateIcon fontSize="inherit" />
            </IconButton>
          </div>
        </div>
      </div>
      <TrainingLocalizationDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
